import {Page} from "./models/Page";
import {Comment} from "./models/Comment";
import {Paginator} from "./models/Paginator";
import {ActionRoot, StateRoot} from "./Root";
import {User} from "./models/User";
import {SignInFetchers} from "./SignIn";

export type ToggleName =
    'checked-sign-in'
    | 'sent-verify-email'
    |
    'commenting'
    | 'generated'
    | 'image-upload-loaded'
    | 'image-upload-in-progress'
    | 'details-complete'
    | 'friend'
    | 'become-friend'
    | 'name-complete'
    | 'content-complete'
    | 'image-complete'
    ;

export type State = {
    user: User | null
    toggles: Set<ToggleName>
    emailVerifying: string
    codeVerifying: string
    signInFetchers: SignInFetchers
}

export type Action = |
    { type: 'change' } |
    { type: 'toggle', payload: ToggleName } |
    { type: 'toggle-set', payload: ToggleName, value: boolean } |
    { type: 'set-user', payload: User | null } |
    { type: 'sign-out' } |
    { type: 'set-email-verifying', payload: string } |
    { type: 'set-code-verifying', payload: string }
    ;



export const defaultReducer = (state: State, action: Action): State | null => {
    switch (action.type) {
        case 'change': {
            return {...state}
        }
        case 'set-user': {
            state.toggles.add('checked-sign-in');
            return {...state, user: (action.payload)};
        }
        case 'sign-out': {
            state.toggles.delete('sent-verify-email');
            state.toggles.delete('checked-sign-in');
            return {...state, user: null, emailVerifying: '', codeVerifying: ''};
        }
        case 'set-email-verifying': {
            return {...state, emailVerifying: (action.payload)};
        }
        case 'set-code-verifying': {
            return {...state, codeVerifying: (action.payload)};
        }
        case 'toggle': {
            let toggles = state.toggles;
            const toggleName = action.payload;
            toggles.has(toggleName) ? toggles.delete(toggleName) : toggles.add(toggleName);
            return {...state, toggles: toggles};
        }
        case 'toggle-set': {
            console.log('toggle-set', action.payload,)
            let toggles = state.toggles;
            const toggleName = action.payload;
            action.value ? toggles.add(toggleName) : toggles.delete(toggleName);
            return {...state, toggles: toggles};
        }
    }
    return null;
}
